import styled from "styled-components";
import React from "react";
import { Cols, FormContainer, Rows } from "./style";
import { useEffect } from "react";
const OverlayMessage = ({ children, ckycResult, isCkycSuccess, Review
}) => {

    return (
        <>
            <FormContainer width='100%'>
                <Rows className='mt-2'>
                    <Cols className='mx-auto text-center' xl={12} lg={12} md={12}>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='47'
                            height='47'
                            viewBox='0 0 47 47'
                        >
                            <path
                                id='prefix__Path_824'
                                d='M0 0h47v47H0z'
                                data-name='Path 824'
                                style={{ fill: "none" }}
                            />
                            <path
                                id='prefix__Path_825'
                                d='M21.583 2a19.583 19.583 0 1 0 19.584 19.583A19.59 19.59 0 0 0 21.583 2zm-3.916 29.375l-9.792-9.792 2.761-2.761 7.03 7.011L32.53 10.969l2.761 2.781z'
                                data-name='Path 825'
                                transform='translate(1.917 1.917)'
                                style={{ fill: "#65c100" }}
                            />
                        </svg>
                        {/* </div> */}
                    </Cols>
                </Rows>
                <div className='stepper-subHeader2 boldFont'>{children}</div>
            </FormContainer>
        </>
    );
};

const OverlayContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`;
export default OverlayMessage;
